// src/Camera.js
import React, { useEffect, useState , useRef} from 'react';
import { Link,useParams,useNavigate  ,useLocation} from 'react-router-dom';
import data from '../json/palette.json'
import API from "../API/api.js";
import { sendAnalyticsData } from '../utilities/analytics';
import Cookies from 'universal-cookie';

const PageResult = () => {


  const [result, setResult] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  // const [btnDisabled, setbtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);

  const [isPhoneNumber,setIsPhoneNumber]= useState('nonfocus')
  const [isEmail,setIsEmail]= useState('nonfocus')
  const [isName,setIsName]= useState('nonfocus')

  const [autoCompleteOpen, setAutoCompleteOpen] = useState(false);
  const [showKeypad, setShowKeypad] = useState(false);

  const emailRef = useRef(null);

  const handleCheckboxChange = () => {
    if(isPhoneNumber==='true'&& isEmail==='true' && isName==='true'){
      setIsChecked(!isChecked);
    }
  };

  const { type } = useParams();
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if(!location.state){
      navigate('/');
      return;
    }
  }, [])

  function checkComplexionName(color){
    let complexionNameArr = data.complexion_name
    return complexionNameArr[color]
  }

async function submitEmail(formData){
    try {
      setIsLoading(true);
      setErrorSubmit(false);
      const cookies = new Cookies();
      let data={
        "fName":formData.name,
        "fEmail":formData.email,
        "fPhone":formData.phone,
        "fEventSource": cookies.get('event_name')
      }
      console.log('DATA:',data);
      // setbtnDisabled(true)
    // let res = await API.submitEmail(data)
    // if(res.status===200){
      // localStorage.removeItem('fID')
      // localStorage.setItem('name', formData.name)

      sendAnalyticsData('API Success','Submit Email')
      sendAnalyticsData('Click','Go To Result Template Page')
      
      // navigate('/'+type+'/result-template',{state:{subseasonal:subseasonal,name:formData.name,complexionName:checkComplexionName(location.state.skintone), skintone: location.state.skintone,seasonal:location.state.seasonal}})
    
    // const ApiResult = 'https://wardahai.pixielab.id/detect/submit';
    const ApiResult = 'https://api-colourintelligence.wardahbeauty.com/detect/submit';

    var payload = {
      'photo': location.state.photo
    }

    fetch(ApiResult, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
      })
      .then((response) => response.json())
      .then((jsonData) => {
        navigate(`/${type}/result-template`, {
          state:{
            photo: location.state.photo,
            name:formData.name,
            email:formData.email,
            phone:formData.phone,
            subseasonal: jsonData.season,
            subseasonalAccuracy: jsonData.season_accuracy,
            subseasonalAlt: jsonData.season_alt,
            subseasonalAccuracyAlt: jsonData.season_alt_accuracy,
            complexionName: checkComplexionName(jsonData.skintone),
            skintone: jsonData.skintone,
          }
        })

        sendAnalyticsData('Click','Go To Result Template Page')
    }).catch(()  => {
      setIsLoading(false);
      setErrorSubmit(true);
    })

    return
    // }
    // console.log('failed send email');
    // return res
    } catch (error) {
      setIsLoading(false);
      setErrorSubmit(true);
      if(error.message[0]==='Already submitted'){
        // localStorage.removeItem('fID')
        // console.log('next page')
        
        return
      }
      sendAnalyticsData('API Failed','Submit Email')

      // navigate('/'+type+'/result-template')
      // console.log('wew');
    }
 
  }

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    submitEmail(formData)
  };

  const handleClickOption = (e) => {
    setAutoCompleteOpen(false);
    
    // Get the selected domain
    const selectedDomain = e.target.innerText;

    // Update the email field with the selected domain
    setFormData((prev) => {
      // If the user already typed part of their email, keep it before the '@'
      let emailPrefix = prev.email.split("@")[0];
      return { ...prev, email: emailPrefix + selectedDomain };
    });
  };

  const handleKeypadClick = (number) => {
    // Update phone number and validate it using handleChange
    setFormData((prev) => {
      const updatedPhone = prev.phone + number;
      // Call handleChange with the updated phone number
      handleChange({ target: { name: 'phone', value: updatedPhone } });
      return { ...prev, phone: updatedPhone };
    });
  };

  const handleDelete = () => {
    setFormData(prev => ({ ...prev, phone: prev.phone.slice(0, -1) }));
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
    if(name==='email'){
      if(!regexEmail(value)){
        setIsChecked(false)
        setIsEmail('false')
        return
      }else{
        setIsEmail('true')
      }
    }
    if(name==='phone'){
      if(!regexPhone(value)){
        setIsChecked(false)
        setIsPhoneNumber('false')
        return
      }else{
        setIsPhoneNumber('true')
      }
    }
    if(name==='name'){
      if(!regexName(value)){
        setIsChecked(false)
        setIsName('false')
        return
      }else{
        setIsName('true')
      }
    }
  };
  const regexEmail=(email)=>{
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
  }
  const regexPhone=(phone)=>{
    return /^(\+62|62|08)[1-9][0-9]{6,10}$/.test(phone);
  }
  const regexName = (name)=>{
    return /^[a-zA-Z ]+$/.test(name)
  }
  return (
    <>
      <div className='container container-fluid container-loading-result'>
        <div className='full-height result-form-wrapper'>
          <div className='page-wrapper d-flex justify-content-center align-items-center flex-column text-center'>
            <Link to={"/"} className='logo-form'>
              <img src='/images/logo.png' alt=''/>
            </Link>
          {!result ? 
            <div className='loading-result-intro d-flex flex-column align-items-center justify-content-center pb-4'>
              <img className='loader-image' src='/images/loader.png' alt=''/>
              <div className='loading-result-title'>
                <h2 className='mb-3 badge-outline'>Analyzing Your Personal Color</h2>
                <h3>please wait a moment</h3>
              </div>
            </div>
            :
            <>
              <form className='form-result' onSubmit={handleSubmit}>
                <div className='form-result-inner'>
                  <input className='form-control text-center' type="text" placeholder="your name" name='name' value={formData.name} onChange={handleChange} required/>
                  <p className={`error-validation ${isName === 'false' ? 'opacity-1' : 'opacity-0'}`}>Name must not be empty</p>
                  
                  <input 
                    ref={emailRef} 
                    className="form-control text-center" 
                    type="email" 
                    placeholder="your email" 
                    name="email" 
                    value={formData.email} 
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })} 
                    onKeyUp={() => setAutoCompleteOpen(true)} 
                    onBlur={(e) => setTimeout(() => {setAutoCompleteOpen(false); handleChange(e)}, 200)} // Delay closing to allow click
                    required
                  />
                  {autoCompleteOpen && (
                    <div className="input-autocomplete open">
                      <p onClick={handleClickOption}>@gmail.com</p>
                      <p onClick={handleClickOption}>@yahoo.com</p>
                      <p onClick={handleClickOption}>@msn.com</p>
                      <p onClick={handleClickOption}>@live.com</p>
                    </div>
                  )}
                  <p className={`error-validation ${isEmail === "false" ? "opacity-1" : "opacity-0"}`}>
                    Email is not valid
                  </p>
                  <input
                    className='form-control text-center'
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onClick={() => setShowKeypad(true)}
                    required
                    readOnly
                    placeholder="Your Phone Number"
                    onChange={handleChange}  // On change for manual typing
                  />
                  {showKeypad && (
                    <div className="keypad">
                      {[...'1234567890'].map(num => (
                        <button key={num} type="button" onClick={() => handleKeypadClick(num)}>
                          {num}
                        </button>
                      ))}
                      <button type="button" onClick={handleDelete}>&larr;</button>
                      <button type="button" onClick={() => setShowKeypad(false)}>OK</button>
                    </div>
                  )}
                  <p className={`error-validation ${isPhoneNumber === 'false' ? 'opacity-1' : 'opacity-0'}`}>Phone number is not valid</p>

                  {/* {HERE IS KEYPAD NUMBER WITH BACK ICON TO DELETE AND OK TO CLOSE} */}

                  <label className='checkbox'>
                    <input
                      name='tnc2'
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    I agree to receive personalized commercial communications from Wardah
                  </label>
                </div>

                {!isLoading || errorSubmit?
                  <button className={`btn btn-primary btn-lg w-100 ${!isChecked  ? 'disabled' : ''}`} type='submit'>Submit</button>
                  :
                  null
                }

                {isLoading ?
                  <>
                    <div className='loading-result-intro d-flex flex-column align-items-center justify-content-center mt-2'>
                      <img className='loader-image' src='/images/loader.png' alt=''/>
                    </div>
                  </>
                  :
                  null
                }
                {errorSubmit ? 
                  <div className='loading-result-intro d-flex flex-column align-items-center justify-content-center mt-4'>
                    <p className='text-danger text-center'>We are in high demand,<br/>please try to submit again!</p>
                  </div>
                  :
                  null
                }
              </form>
            </>
          }
          </div>
        </div>
      </div>
    </>
  );
};

export default PageResult;